<template>
    <div class="table-container">
        <el-table
            :data="data"
        >
            <el-table-column
                v-if="isWeekly || isDaily"
                min-width="110"
                :prop="isWeekly?'week':'date'"
                :label="isWeekly?'Semaine':'Date'"
                :formatter="isDaily?formattedDate:null"
            >
            </el-table-column>
            <el-table-column
                min-width="110"
                prop="operating_time_consumption_mwh"
                label="Consommation en fonctionnement (MWh)"
                :formatter="formatNumber"
            >
            </el-table-column>
            <el-table-column
                min-width="110"
                prop="average_power_kw"
                label="Puissance moyenne (kW) en fonctionnement"
                :formatter="formatNumber"
            >
            </el-table-column>
            <el-table-column
                min-width="110"
                prop="minimum_power_kw"
                label="Puissance minimale (kW)"
                :formatter="formatNumber"
            >
            </el-table-column>
            <el-table-column
                min-width="110"
                prop="maximum_power_kw"
                label="Puissance maximale (kW)"
                :formatter="formatNumber"
            >
            </el-table-column>
            <template
                v-if="isEquipment"
            >
                <template
                    v-if="isGlobal"
                    >
                    <el-table-column
                        min-width="110"
                        prop="first_pmax_range_time_percent"
                        label="% de temps à [0%;25%[ de Pn"
                        :formatter="formatNumber"
                    >
                    </el-table-column>
                    <el-table-column
                        min-width="110"
                        prop="second_pmax_range_time_percent"
                        label="% de temps à [25%;50%[ de Pn"
                        :formatter="formatNumber"
                    >
                    </el-table-column>
                    <el-table-column
                        min-width="110"
                        prop="third_pmax_range_time_percent"
                        label="% de temps à [50%;75%[ de Pn"
                        :formatter="formatNumber"
                    >
                    </el-table-column>
                    <el-table-column
                        min-width="110"
                        prop="fourth_pmax_range_time_percent"
                        label="% de temps à >75% de Pn"
                        :formatter="formatNumber"
                    >
                    </el-table-column>
                </template>
                <el-table-column
                    min-width="110"
                    prop="stop_power_kw"
                    label="Puissance à l'arrêt (kW)"
                    :formatter="formatNumber"
                >
                </el-table-column>
                <el-table-column
                    min-width="110"
                    prop="start_count"
                    label="Nombre démarrages"
                >
                </el-table-column>
                <el-table-column
                    min-width="110"
                    prop="above_stop_power_operating_time_percent"
                    label="Pourcentage de temps de fonctionnement à puissance supérieur à la puissance d'arrêt (%)"
                    :formatter="formatNumber"
                >
                </el-table-column>
            </template>
            <template
                v-else
            >
                <el-table-column
                    v-if="!isEquipment"
                    min-width="110"
                    prop="baseload_power_kw"
                    label="Puissance du talon (kW)"
                    :formatter="formatNumber"
                >
                </el-table-column>
                <el-table-column
                    min-width="110"
                    prop="above_baseload_power_operating_time_percent"
                    label="Pourcentage de temps de fonctionnement à puissance supérieur à la puissance du talon (%)"
                    :formatter="formatNumber"
                >
                </el-table-column>
            </template>
        </el-table>
    </div>
</template>

<script>
    import moment from 'moment';
    export default {
        name: 'GlobalDataView',
        props:{
            entity:{
                type: String,
                required: true
            },
            data:{
                type: Array,
                required: true
            },
            tableType:{
                type: String,
                required: true
            }
        },
        computed: {
            isGlobal(){
                return this.tableType === 'global';
            },
            isDaily(){
                return this.tableType === 'daily';
            },
            isWeekly(){
                return this.tableType === 'weekly';
            },
            isEquipment(){
                return this.entity === 'motor' || this.entity === 'machine';
            },
        },
        methods: {
            formatNumber(row, column, cellValue) {
                if (cellValue === null || cellValue === undefined || cellValue === '') {
                    return '';
                }
                const numericValue = typeof cellValue === 'number'
                    ? cellValue
                    : parseFloat(String(cellValue).replace(',', '.'));
                if (!isFinite(numericValue)) {
                    return cellValue;
                }
                const propName = column && (column.property || column.prop);
                const isPercent = typeof propName === 'string' && propName.indexOf('percent') !== -1;
                if (isPercent) {
                    return (numericValue * 100).toFixed(2) + ' %';
                }
                return numericValue.toFixed(2);
            },
            formattedDate(row, column, cellValue){
                return moment(cellValue).local().format("DD/MM/YYYY")
            }
        },
    }
</script>

<style lang="scss" >

</style>


// WEBPACK FOOTER //
// src/components/page/DataView/ConsumptionTable.vue